// extracted by mini-css-extract-plugin
export default {"div1":"CarouselDown_div1__jjqIw","img":"CarouselDown_img__Ai86X"};